import React, { Component } from "react";
import { Form} from 'semantic-ui-react';
import  Logo  from "./logo";
import CustomField from "./CustomField";
import trocaSenhaImg from "../img/esqueci-minha-senha-topo.png";
import formatError from "../js/formatError"
import { isIOS, isSafari, isChrome, isFirefox } from 'react-device-detect';
import apiEsqueciSenha from "../core/apiEsqueciSenha";
import ValidacaoBrowser from "./ValidacaoBrowser";

class ValidacaoEsqueciSenha extends Component {

  constructor(props){
    super(props);
    this.state = {
      camposValidacao:[],
      nomeMae: "",
      cpf: "",
      error: "",
      resultsMessage: "",
      mensagemSmsEnviado:"",
      valoresValidacao:new Map(),
      codigoSms:"",
      usuario:"",
      loading: false,
    };
  }

  
  handleCancelar = async e => {
    if(window.confirm("Atenção: Tem certeza que deseja cancelar o processo de Esqueci Minha Senha?")) {
      this.setState({
      camposValidacao:[],
      nomeMae: "",
      cpf: "",
      error: "",
      resultsMessage: "",
      mensagemSmsEnviado:"",
      valoresValidacao:new Map(),
      codigoSms:"",
      usuario:"",
      loading: false
      });
      this.props.history.push("/");
    }
  }

  handleUsuarioOnBlur = async e => {
    e.persist();
    if(!(e.target.value ==="")){
      this.setState({
        usuario: e.target.value 
      });
    }
  }

  handleContinuar = async e => {
    this.setState({ loading: true });
    this.setState({
      resultsMessage:"",
      error:""
    });
    e.persist();
    if(!(this.state.usuario==="")  && this.state.camposValidacao.length === 0){
      try {
        await apiEsqueciSenha.post("/buscarCampos?userName="+this.state.usuario)
          .then(res => {
                if(res.data.length === 0){
                  this.setState({
                    resultsMessage: 'Não será possível redefinir seu usuário/senha. Motivo: Usuário informado não localizado. Favor contatar a área responsável pelo seu cadastro: Central de Identificação ou CGP.',
                    error:""
                  });
                }else{
                  this.setState({
                    camposValidacao: res.data, 
                    resultsMessage:"",
                    error:"",
                  });
              }
            }
          );
        } catch (err) {
          if(err.message ==='Request failed with status code 400'){
            this.setState({
              resultsMessage: err.response.data,
              error:""
            });
          }else{
            formatError(err.response, this);
          }
       }
      
    }else if(!(this.state.usuario==="") && this.state.camposValidacao.length > 0){

        e.persist();
        const mapa = [];
        //debugger;
        for(var i = 0, keys = this.state.valoresValidacao.keys(), k= keys.next(); i < this.state.valoresValidacao.size; i++, k = keys.next()){
          mapa.push({[k.value]:this.state.valoresValidacao.get(k.value)});
        }
        //console.log(JSON.stringify(mapa));
        try {
          await apiEsqueciSenha.post("/valid", {dados:JSON.stringify(mapa)},{params :{"userName":this.state.usuario}})
            .then(res => {
                this.setState({
                  mensagemSmsEnviado: res.data,
                  resultsMessage:"",
                  error:""
                });
              }
            );

            if(this.state.mensagemSmsEnviado){
              this.props.history.push("/envioSms",{passo:2, usuario: this.state.usuario, mensagemSmsEnviado: this.state.mensagemSmsEnviado});
            } 
        } catch(err) {
          if(err.message ==='Request failed with status code 400'){
            this.setState({
              resultsMessage: err.response.data,
              error:""
            });
          }else{
            formatError(err.response, this);
          }
        }
    }

    this.setState({ loading: false });
  };
  
  _setValorCampo(nm, vlr){
    //console.log("nome:["+nm+"] valor:["+ vlr +"]");
    this.state.valoresValidacao.set(nm, vlr);
    //console.log(this.state.valoresValidacao);
  }

  isValidBrowser() {
    if ((isIOS && isSafari )|| isChrome || isFirefox) {
      return true;
    }
    return false;
  }

  isDadosPreenchidosEsqueciSenha(){
    if (!(this.state.usuario ==="") && this.state.camposValidacao.length() > 0) {
      return true;
    }
    return false;
  }


  render() {
    const { loading } = this.state;
    if (!this.isValidBrowser()) {
      return ( <ValidacaoBrowser /> );
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <h5 className="card-title text-center margin-top">
              <img src={trocaSenhaImg} className="img-responsive troca-senha" alt="Confirmação de Dados" />
            </h5>
            <p>Confirmação de Dados</p>
            <Form id="esqueciSenha" onSubmit={this.handleContinuar} autoComplete="off">
                {this.state.error && <div className="msgError center">{this.state.error}</div>}
                {this.state.resultsMessage && <div className="msgWarning center">{this.state.resultsMessage}</div>}
              
                <input 
                type="text" 
                id="usuario" 
                autoFocus={true}
                className="form-control margin-button-input bkg-verde" 
                placeholder="Usuário" 
                maxLength="30"
                onChange={this.handleUsuarioOnBlur} 
                onBlur={this.handleUsuarioOnBlur}
                disabled={this.state.camposValidacao.length > 0}
                required />
                
              <div id="root">
                {this.state.camposValidacao && this.state.camposValidacao.map((v, i) =>
                  <div key={i}>
                    <CustomField 
                      autoFocus={i===0}
                      type={v.tipo}
                      id={v.nome}
                      title={v.descricao}
                      value={v.valor}
                      help={v.help}
                      maxLength={v.tamanho}
                      className="form-control margin-button-input margin-top-input bkg-verde" 
                      placeholder={v.help} 
                      options={v.opcoes}
                      action={(nome, valor)=> this._setValorCampo(nome, valor)}
                      selected={this.state[v.nome]}
                        />
                  </div>
                )}   
              </div>

              <button id="btnContinuar" className="btn btn-primary btn-block margin-top-input text-uppercase" type="submit"
              disabled={(this.state.usuario ==="") || loading}>
                  {loading ? 'CARREGANDO...' : 'CONFIRMAR'}
              </button>
              <button id="btnCancelar"  disabled={loading} className="btn btn-secondary btn-block text-uppercase" type="reset" onClick={this.handleCancelar}>CANCELAR</button>


              <Logo />
            </Form>
          </div>
        </div>
      </div>
    );
  }
}

export default ValidacaoEsqueciSenha;
